import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import AppErrorHandler from '../components/atoms/AppErrorHandler'
import AppErrorPage from '../pages/AppErrorPage'
import routes from './routes'

function RouterApp(): JSX.Element {
  return (
    <BrowserRouter>
      <Switch>
        {routes.map((route, key) => (
          <Route
            key={key}
            path={route.path}
            exact={route.exact}
            strict={route.strict}
          >
            {(routeProps) => {
              return (
                <AppErrorHandler
                  fallback={
                    <AppErrorPage {...routeProps} pageName='Internal Error' />
                  }
                >
                  <route.component
                    {...routeProps}
                    routes={route.routes}
                    pageName={route.pageName}
                  />
                </AppErrorHandler>
              )
            }}
          </Route>
        ))}
      </Switch>
    </BrowserRouter>
  )
}

export default RouterApp
